<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      福海西站<br>
站点介绍<br>
车站位于松福大道于桥和路交叉路口，沿桥和路东西向敷设。车站设置有4个出入口，其中C口为主要紧急出入口，有盲道及垂直电梯通往站厅，D口为备用紧急出入口。B口为海上田园东公交接驳口，D口为左炮台东方向公交接驳口。周边主要分布了泰德创新科技园、德金数据通信产业园、天源隆商场、瑞和公馆、百港城和平中心等多个项目，车站周边现状以住宅和商业为主，兼有商业贸易、绿化等多种功能的综合居住区。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
左炮台东	06:22	00:02	12号线	4分钟	8分钟<br>
海上田园东	06:29	23:09	12号线	4分钟	8分钟<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
左炮台东	06:23	00:02	12号线	8分钟	8分钟<br>
海上田园东	06:29	23:09	12号线	8分钟	8分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
左炮台东	－	－	12号线	－	－<br>
海上田园东	－	－	12号线	－	－<br><br>

站点出口信息<br><br>
A出入口:<br>
桥和路南侧 德金数据通信产业园、中国银行、天源隆商场（和平店）、中影德金影城、福永法庭、德金花园<br><br>
B出入口:<br>
桥和路南侧 百港城·和平中心、盛世华联、金丰智汇谷<br><br>
C出入口:<br>
桥和路北侧 泰德创新科技园、思源工业区、和平时尚广场、深圳农商银行、和平社区<br><br>
D出入口:<br>
桥和路北侧 夏威夷国际酒店、和泰工业区、智鹏工业园、福海国际科技园、美颂会展酒店、九阳工业园、瑞和公馆、恒诚公寓<br>
公交换乘信息<br><br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "shierhaoxian",
            title: "12号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>